import publicBuill from '../../../../components/reimbursement/js/publicBuill'
import invoiceTable from '../../../../components/reimbursement/invoiceTable'

export default {
  name: 'oaFybxd',
  components: {
    invoiceTable
  },
  data() {
    return {
      bxnrArr: [
        {
          bxnr: '',
          bxje: ''
        },
        {
          bxnr: '',
          bxje: ''
        }
      ],
      djh: '',
      jkr: '',
      jkrid: '',
      jexx: '',
      jedx: '',
      rq: '',
      sfpj: '',
      bz: '',
      hrdwzh: '',
      hrdwkhh: '',
      jkrYsDeptCode: '',
      jkrYsDeptName: '',
      ljjk: '0.00',
      yhk: '0.00',
      jkje: '0.00',
      optionsFyBxnr: [],
      optionsFyBxUser: [],
      activeName: 'second',
      user: {},
      saveBtn: true,
      invoiceArr: []


    }
  },
  mounted() {
    this.user = localStorage
    if (this.user.userNo === '51544') {
      this.user.companyTitle = '吴忠仪表检修服务分公司'
      this.user.companyId = '10'
      this.saveBtn = false
    } else {
      publicBuill.companyNameQuery(this.user.company).then(res => {
        if (!this.user.companyTitle || this.user.companyTitle === '' || !this.user.companyId || this.user.companyId === '') {
          this.saveBtn = true
          this.$message.error('公司信息获取失败，请联系管理员！！！')
        } else {
          this.saveBtn = false
        }
      })
    }
    this.initData()
  },
  created() {
    publicBuill.setThis(this)
    publicBuill.getFyBxnr()
    publicBuill.getFyBxUser().then(res => {
      this.optionsFyBxUser.forEach(value => {
        if (value.subjectName === this.user.userName) {
          const itemArr = [value.subjectName, value.subjectCode, value.dictCode, value.dictName]
          this.changejkr(itemArr)
        }
      })
    })
  },
  methods: {
    initData() {
      this.optionsFyBxUser.forEach(value => {
        if (value.subjectName === this.user.userName) {
          const itemArr = [value.subjectName, value.subjectCode, value.dictCode, value.dictName]
          this.changejkr(itemArr)
        }
      })
      this.bxnrArr = [{ bxnr: '', bxje: '' }, { bxnr: '', bxje: '' }]
      this.ljjk = '0.00'
      this.yhk = '0.00'
      this.jkje = '0.00'
      this.rq = publicBuill.dateToString(new Date())
    },
    addBxnr() {
      const temp = {
        bxnr: '',
        bxje: ''
      }
      if (this.bxnrArr.length <= 9) {
        this.bxnrArr.push(temp)
      }
    },
    reduceBxnr() {
      if (this.bxnrArr.length > 2) {
        this.bxnrArr.pop()
        let je = 0.0
        this.bxnrArr.forEach(value => {
          if (value.bxje !== null && value.bxje !== '')
            je = (parseFloat(value.bxje) + parseFloat(je)).toFixed(2)
        })
        this.jexx = je
        this.jedx = publicBuill.convertCurrency(je)
      }
    },
    changejkr(event) {
      this.jkr = event[0]
      this.jkrid = event[1]
      this.$post('/fesback/fybxd/queryFybxdByJkr.z', { jkr: this.jkr }).then(res => {
        this.hrdwkhh = res.hrdwkhh
        this.hrdwzh = res.hrdwzh
      })
      this.$post('/fesback/fybxd/getUserYsInfo.z', { jkr: this.jkr }).then(res => {
        this.jkrYsDeptCode = res.jkrYsDeptCode
        this.jkrYsDeptName = res.jkrYsDeptName
      })
    },
    async submitForm() {
      const loading = this.$loading({
        lock: true,
        text: '数据保存中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const data = {
        jkr: this.jkr,
        jkrid: this.jkrid,
        bz: this.bz,
        sfpj: this.sfpj,
        je: this.jexx,
        bmbm: localStorage.getItem('deptNo'),
        bmmc: localStorage.getItem('groupName'),
        lrr: localStorage.getItem('userName'),
        lrrId: localStorage.getItem('userNo'),
        rejected: '0',
        companyId: this.user.companyId,
        hrdwzh: this.hrdwzh,
        hrdwkhh: this.hrdwkhh
      }
      if (this.jkrYsDeptCode && this.jkrYsDeptName && this.jkrYsDeptCode !== '' && this.jkrYsDeptName !== '') {
        data.jkrYsDeptCode = this.jkrYsDeptCode
        data.jkrYsDeptName = this.jkrYsDeptName
      }
      this.bxnrArr.forEach((value, index) => {
        const bxnr = 'bxnr' + (index + 1)
        const bxje = 'bxje' + (index + 1)
        data[bxnr] = value.bxnr
        if (value.bxje === '') {
          value.bxje = '0.00'
        }
        data[bxje] = value.bxje
      })
      for (let i = this.bxnrArr.length + 1; i <= 10; i++) {
        const notbxje = 'bxje' + (i)
        data[notbxje] = 0
      }
      if (data.jkr === '') {
        this.$message.error('报销人不能为空')
        loading.close()
      } else if (this.hrdwzh === '') {
        this.$message.error('汇入账号不能为空')
        loading.close()
      } else if (this.hrdwkhh === '') {
        this.$message.error('汇入开户行不能为空')
        loading.close()
      } else if (this.jexx === '' || this.jexx <= 0) {
        this.$message.error('金额不能为空或小于0')
        loading.close()
      } else if (data.bxnr1 === '' || data.bxje1 === '' || !data.bxje1 || !data.bxnr1 || data.bxje1 <= 0) {
        this.$message.error('报销内容填错误，请检查！！！')
        loading.close()
        // else if (this.invoiceArr.length < 1) {
        //   this.$message.error('必须填写发票信息！！！')
        //   loading.close()
        // }
      } else {
        const r1 = await this.$post('/fesback/fybxd/save.z', data).then(response => {
          return response
        }).catch(err => {
          return { message: '非预期错误' + err, success: false }
        })
        if (r1.success) {
          this.resetForm()
        } else {
          loading.close()
          this.$message.error(r1.message)
          return
        }
        if (this.invoiceArr.length > 0) {
          const r2 = await publicBuill.vatInvoiceUpload(r1.data)
          if (r2.success) {
            this.$refs.invoiceTable.invoiceArrReset()
          } else {
            this.$message.warning(r2.message)
            loading.close()
            return
          }
        }
        loading.close()
        this.$message({
          type: 'success',
          message: '保存成功!'
        })
      }
    },
    /* 报销内容的金额改变时触发 */
    jeChange() {
      let je = 0.0
      let a = false
      this.bxnrArr.forEach(value => {
        if (value.bxje !== '') {
          if (value.bxnr && value.bxnr !== '' && value.bxje <= 0) {
            a = true
            this.$message.error('金额不能小于0')
            return
          }
          if (value.bxje !== null && value.bxje !== '') {
            value.bxje = parseFloat(value.bxje).toFixed(2)
            je = (parseFloat(value.bxje) + parseFloat(je)).toFixed(2)
          }
        }
      })
      if (a) {
        this.jexx = 0
      }
      this.jexx = je
      this.jedx = publicBuill.convertCurrency(je)
    },
    resetForm() {
      const data = this.$data
      Object.keys(data).forEach(key => {
        if (typeof data[key] === 'string' && !(key === 'activeName' || key === 'jkr' || key === 'jkrid')) {
          data[key] = ''
        }
      })
      this.initData()
    },
    backFill(val) {
      this.$message.success('该单据不具备回填功能。')
    },
    updateInvoice(val) {
      this.invoiceArr = val
    }
  }
}
